import React from "react"
import {
  FilterRow,
  Container,
  FilterRowTitle,
  FilterButtonText,
  FilterButton,
  FilterIndicator,
  FilterFooter,
  FilterInner,
  FilterCheckBox,
  FilterTextLabel,
  FilterText,
  FilterTitle,
  FilterRowCheckBox,
} from "./styles/Filters.styled"

const Filters = ({ children }) => {
  return <Container>{children}</Container>
}

Filters.FilterRow = ({ children, ...restProps }) => {
  return <FilterRow {...restProps}>{children}</FilterRow>
}

Filters.FilterText = ({ children, ...restProps }) => {
  return <FilterText {...restProps}>{children}</FilterText>
}

Filters.FilterTitle = ({ children, ...restProps }) => {
  return <FilterTitle {...restProps}>{children}</FilterTitle>
}

Filters.FilterRowTitle = ({ children, ...restProps }) => {
  return <FilterRowTitle {...restProps}>{children}</FilterRowTitle>
}

Filters.FilterRowCheckBox = ({ children, ...restProps }) => {
  return <FilterRowCheckBox {...restProps}>{children}</FilterRowCheckBox>
}

Filters.FilterButton = ({ children, ...restProps }) => {
  return <FilterButton {...restProps}>{children}</FilterButton>
}

Filters.FilterButtonText = ({ children, ...restProps }) => {
  return <FilterButtonText {...restProps}>{children}</FilterButtonText>
}

Filters.FilterIndicator = ({ children, ...restProps }) => {
  return <FilterIndicator {...restProps}>{children}</FilterIndicator>
}

Filters.FilterFooter = ({ children, ...restProps }) => {
  return <FilterFooter {...restProps}>{children}</FilterFooter>
}

Filters.FilterInner = ({ children, ...restProps }) => {
  return <FilterInner {...restProps}>{children}</FilterInner>
}

Filters.FilterFooter = ({ children, ...restProps }) => {
  return <FilterFooter {...restProps}>{children}</FilterFooter>
}

Filters.FilterInner = ({ children, ...restProps }) => {
  return <FilterInner {...restProps}>{children}</FilterInner>
}

Filters.FilterCheckBox = ({ children, ...restProps }) => {
  return <FilterCheckBox {...restProps}>{children}</FilterCheckBox>
}

Filters.FilterTextLabel = ({ children, ...restProps }) => {
  return <FilterTextLabel {...restProps}>{children}</FilterTextLabel>
}

export default Filters
